import FAQElement from "components/FAQ";
import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

const FAQs = () => {
  const faqs = [
    {
      q: "What platforms does Rated Afrika distribute to?",
      a: "Rated Afrika distributes your music and videos to all major platforms, including Spotify, Apple Music, YouTube, and more. We’re constantly expanding our list to help you reach as many listeners as possible."
    },
    {
      q: "How does royalty management work on Rated Afrika?",
      a: "Our customizable royalty management tool lets you assign specific revenue splits to each contributor, ensuring everyone gets paid fairly. Royalties are tracked and distributed automatically, so you don’t have to worry about managing payments."
    },
    {
      q: "Can I upload both music and videos?",
      a: "Yes! Rated Afrika supports unlimited uploads for both music and video content. We make it easy to share all your creative work with the world."
    },
    {
      q: "What subscription plans are available?",
      a: "We offer flexible subscription plans for every stage of your career—from an affordable plan for independent artists to a more advanced package for labels and managers. Each plan is designed to provide the best features based on your needs."
    },
    {
      q: "Can I track the performance of my releases?",
      a: "Absolutely! Rated Afrika provides detailed analytics on streams, downloads, and engagement metrics across platforms. You’ll have insights into who’s listening, where they’re tuning in from, and how they’re engaging with your content."
    }
  ];
  return (
    <Container>
      <Typography
        align="center"
        size="4rem"
        weight="semibold"
        mb="2"
        m_size="2.4rem"
      >
        Frequently asked questions
      </Typography>
      <Typography
        align="center"
        size="xl"
        m_size="lg"
        color={Colors.grey400}
        mb="6.4"
      >
        Everything you need to know about Rated Afrika
      </Typography>
      <FAQContainer>
        {faqs.map((faq, i) => {
          return (
            <Item key={i}>
              <FAQElement q={faq.q} a={faq.a} />
            </Item>
          );
        })}
      </FAQContainer>
    </Container>
  );
};

export default FAQs;

const Container = styled.div`
  color: white;
  padding-top: 6.4rem;
  padding-bottom: 9.6rem;
  @media only screen and (max-width: 769px) {
    padding: 3.2rem 0;
  }
`;

const FAQContainer = styled.div`
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  @media only screen and (max-width: 769px) {
    width: 90%;
  }
`;

const Item = styled.div`
  margin-bottom: 3.2rem;
  width: 100%;
`;
